module.exports = __webpack_public_path__ + "static/media/portfolioScreenshot.ab587975.png";